import CustomTextField from "components/CustomTextField";
import {
  Col,
  Input,
  Row,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { Modal, Spinner, Button, Table } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import {
  useGetAllBankOfUsersQuery,
  useCreateBankDetailsMutation,
  useUpdateBankByIdMutation,
} from "./farmerApiSlice";
import { useEffect, useState } from "react";
import { useGetIfscQuery } from "services/BankBranchesApiSlice";
import Select from "react-select";
import { toast } from "react-toastify";
import FarmerNoResponse from "./FarmerNoResponse";
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { LoaderDesign } from "./LoaderDesign";
import { EyeFilled } from "@ant-design/icons";
import { Badge } from "antd";
import { Cancel } from "@mui/icons-material";
import CardSkeleton from "components/CardSkeleton";
import { Divider } from "@mui/material";
const FarmerDetailsBank = ({ tabIndex }) => {
  const { id } = useParams();
  const location = useLocation();
  const fullname = location.state?.fullname || "";
  const { data: data, isLoading, refetch } = useGetAllBankOfUsersQuery(id);
  const [Group, editGroup] = useState({
    account_number: "",
    account_type: "",
    account_holder: "",
  });
  const [BankList, setBankList] = useState([]);
  const [BackupBankList, setBackupBankList] = useState([]);
  const [showAddModal, setshowAddModal] = useState(false);
  const [showError, setError] = useState(false);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bankIfscCode, setIfscCode] = useState("");
  const [clickedIndexEdit, setIndex] = useState();
  const [currentEditingItem, setCurrentEditingItem] = useState([]);
  const [disableButton, disableSubmitBtn] = useState(false);
  const { data: bankIfsc } = useGetIfscQuery(bankIfscCode);
  const [createBank, createBankResponse] = useCreateBankDetailsMutation();
  const [updateBank, updateBankResponse] = useUpdateBankByIdMutation();
  const [bankLoading, setBankLoading] = useState(false);
  // console.log("bankIfsc",bankIfsc)
  const [bankIfscCodeList, setIfscCodeList] = useState({
    branchName: "",
    bankName: "",
  });
  const [BankIfscOptions, setBankIfscOptions] = useState([]);
  const [showFieldsWhileEditing, setshowFieldsWhileEditing] = useState(false);
  const [showLoader, setLoader] = useState(false);

  useEffect(() => {
    const userFromApi = data?.data ? data?.data : BankList;
    if (userFromApi !== undefined) {
      setBankList(userFromApi);
      setBackupBankList(userFromApi);
      setBankLoading(false);
    }
  }, [data]);
  const customStyles = {
    control: (base) => ({
      ...base,
      height: 43,
      minHeight: 43,
    }),
  };
  const handleEditBank = (index, item) => {
    setIndex(index);
    setEdit(true);
    setCurrentEditingItem(item);
    setIfscCode(item.IFSC);
    setIfscCodeList({ branchName: item.branch_name, bankName: item.bank_name });
  };
  const AddModal = () => {
    setshowAddModal(true);
    setBankIfscOptions([]);
    setIfscCodeList({ branchName: "", bankName: "" });
  };
  const handleClose = () => {
    setshowAddModal(false);
    setIfscCode("");
    setIfscCodeList({ branchName: "", bankName: "" });
  };
  const onInputChange = (event) => {
    editGroup({
      ...Group,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    // console.log("modifying response bank", bankIfsc)
    let bankList = [];
    if (bankIfsc) {
      // console.log("bankIfsc.data.results", bankIfsc.data.results)
      // setIfscCodeList(bankIfsc.data.results)
      let responseAgentArray = [];
      bankIfsc.data.results.map((bank) => {
        responseAgentArray.push({
          value: bank.branch_name,
          label: bank.IFSC,
          branchName: bank.branch_name,
          bankName: bank.bank_name,
        });
      });
      // console.log("responseAgentArray", responseAgentArray)
      setBankIfscOptions(responseAgentArray);
    }
  }, [bankIfsc]);

  const handleAddSubmit = () => {
    var sendAddPayload = {
      ...Group,
      branch_name: bankIfscCodeList.branchName,
      bank_name: bankIfscCodeList.bankName,
      IFSC: bankIfscCodeList.label,
    };
    disableSubmitBtn(true);
    // console.log("sendAddPayload", sendAddPayload)
    createBank({ id: id, payload: sendAddPayload })
      .unwrap()
      .then((data) => {
        // toast.success("Bank Account Created")
        swal("Account Created Successfully", {
          buttons: false,
          icon: "success",
          title: "Successfully Created Account",
          timer: 1500,
        });
        // console.log("data", data)
        disableSubmitBtn(false);
        setshowAddModal(false);
        refetch();
      })
      .catch((error) => {
        toast.error("Error while Creating Farmer");
        disableSubmitBtn(false);
        return;
      });
  };
  const onIfscChange = (e) => {
    setIfscCode(e.label);
    setshowFieldsWhileEditing(true);
    setIfscCodeList(e);
    setBankLoading(true);
  };
  const onIfscKeyUp = (e) => {
    // console.log("onKeyUp", bankIfsc.data.results)
    setIfscCode(e.target.value);
    setBankLoading(true);
  };
  const handleClear = () => {
    setEdit(false);
    setIndex();
    setBankList(BackupBankList);
    setshowFieldsWhileEditing(false);
  };
  const EditInputChange = (e) => {
    e.preventDefault();
    setCurrentEditingItem({
      ...currentEditingItem,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmitEdit = () => {
    setLoading(true);
    let updateBankPayload = {
      IFSC: bankIfscCodeList.label,
      bank_name: bankIfscCodeList.bankName,
      branch_name: bankIfscCodeList.branchName,
      account_holder: currentEditingItem.account_holder,
      account_number: currentEditingItem.account_number,
      account_type: currentEditingItem.account_type,
    };
    let updateId = currentEditingItem.id;
    updateBank({ id: updateId, payload: updateBankPayload })
      .unwrap()
      .then((data) => {
        // toast.success("Bank Account Updated")
        swal("Account Updated Successfully", {
          buttons: false,
          icon: "success",
          title: "Successfully Updated Account",
          timer: 1500,
        });
        setshowFieldsWhileEditing(false);
        setEdit(false);
        setIndex();
        refetch();
      })
      .catch((error) => {
        toast.error("Error while Updating Bank");
        return;
      });
  };
  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };
  return (
    <Card className="globalboxshadow">
   
      <div
             className="d-flex justify-content-between  align-items-center "
             style={{ borderRadius: "5px",backgroundColor:"#f1f1f1" }}
           >
             <div className="heading-title mt-lg-0 mt-2 py-3">
                     <h5
                       className="mx-4"
                       style={{
                         fontSize: "18px",
                         color: "black",
                       }}
                     >
                       <i
                         className="mdi mdi-account-hard-hat me-2"
                         style={{ fontSize: "1.5rem" }}
                       ></i>
                       {fullname}
                     </h5>
                   </div>
             <div
               className="d-flex justify-content-end align-items-center flex-wrap"
               style={{ gap: "6px" }}
             >
               <Button
                 id="AddDetails99"
                 type=""
                 className="buttonOrangeDefaultColor"
                 onClick={() => AddModal()}
                 size="sm"
               >
                 Add <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
               </Button>
               <Button
                 className="bg-transparent text-black fs-6 reloadButton me-2"
                 size="sm"
                 onClick={ReloadApplication}
               >
                Reload <FontAwesomeIcon icon={faRotateLeft} />
               </Button>
               </div>
           </div>
      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : BankList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <Row>
          {BankList.map((item, index) => {
            return (
              <>
                <div className="page-content col-12 ">
                  <Col lg="12">
                    <div className="transparent_card custom_mb">
                      <Divider style={{ borderTop: "2px dotted orange",marginBottom:"5px" }} />
                      <div className="p-1 p-lg-3">
                        <div className="d-lg-block d-md-none d-none">
                          <Row className="text-gray ">
                            <Col lg="4" className="mb-2">
                              {edit && clickedIndexEdit === index ? (
                                <>
                                  <label className="text-black">IFSC</label>
                                  <Select
                                    defaultValue={{
                                      label: item.IFSC,
                                      value: 0,
                                    }}
                                    options={BankIfscOptions}
                                    onKeyDown={onIfscKeyUp}
                                    isLoading={bankLoading}
                                    onChange={onIfscChange}
                                    styles={customStyles}
                                    disabled={
                                      clickedIndexEdit != index ? true : false
                                    }
                                    className="mt-2"
                                  />
                                </>
                              ) : (
                                <CustomTextField
                                  type="text"
                                  name="IFSC"
                                  value={item.IFSC}
                                  disabled={
                                    clickedIndexEdit != index ? true : false
                                  }
                                  onChange={EditInputChange}
                                />
                              )}
                            </Col>
                            <Col lg="4" className="mb-2">
                              <CustomTextField
                                type="text"
                                name="bank_name"
                                value={
                                  clickedIndexEdit === index &&
                                  showFieldsWhileEditing
                                    ? bankIfscCodeList.bankName
                                    : item.bank_name
                                }
                                disabled
                              />
                            </Col>
                            <Col lg="4" className="mb-2">
                              <CustomTextField
                                type="text"
                                name="branch_name"
                                value={
                                  clickedIndexEdit === index &&
                                  showFieldsWhileEditing
                                    ? bankIfscCodeList.branchName
                                    : item.branch_name
                                }
                                disabled
                              />
                            </Col>
                            <Col lg="4" className="mb-2 mt-2">
                              <CustomTextField
                                type="text"
                                name="account_number"
                                defaultValue={item.account_number}
                                disabled={
                                  clickedIndexEdit != index ? true : false
                                }
                                onChange={EditInputChange}
                              />
                            </Col>
                            <Col lg="4" className="mb-2 mt-2">
                              <CustomTextField
                                type="text"
                                name="account_holder"
                                defaultValue={item.account_holder}
                                disabled={
                                  clickedIndexEdit != index ? true : false
                                }
                                onChange={EditInputChange}
                              />
                            </Col>
                            <Col lg="4" className="mb-2 mt-2">
                              <label className="text-black">
                                Type of Account
                              </label>
                              <Input
                                type="select"
                                className="form-control mt-2 fs-6 "
                                // name="account_type"
                                style={{
                                  padding: "7px",
                                }}
                                defaultValue={item.account_type}
                                disabled={
                                  clickedIndexEdit != index ? true : false
                                }
                                onChange={EditInputChange}
                              >
                                <option value="select">Select Type</option>
                                <option id="Saving" value="Saving Account">
                                  Savings Account
                                </option>
                                <option id="Current" value="Current Account">
                                  Current Account
                                </option>
                                <option id="Loan" value="Loan Account">
                                  Current Account
                                </option>
                              </Input>
                            </Col>
                          </Row>
                        </div>
                        <div className="hover-shadow d-lg-none d-md-block d-block rounded-3 bg-white p-3">
                          <CardTitle className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center">
                              <Badge
                                className="f400"
                                style={{ fontSize: "18px", color: "#FF8C00" }}
                              />
                              <span
                                className="font-weight-bold"
                                style={{
                                  fontSize: "15px",
                                  color: "#333",
                                  marginLeft: "8px",
                                }}
                              >
                                {item.IFSC || "N/A"}{" "}
                              </span>
                            </div>
                            {edit && clickedIndexEdit === index ? (
                              <Cancel
                                className="text-danger"
                                style={{
                                  fontSize: "20px",
                                  transition: "color 0.3s ease",
                                }}
                                onClick={() => handleClear()}
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={faPenToSquare}
                                className="f400 cursor-pointer"
                                onClick={() => handleEditBank(index, item)}
                                style={{
                                  fontSize: "16px",
                                  color: "#FF8C00",
                                  transition: "color 0.3s ease",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.color = "#FF5722")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.color = "#FF8C00")
                                }
                              />
                            )}
                          </CardTitle>
                          <hr
                            className="mt-0 mb-2"
                            style={{ borderColor: "#FF8C00" }}
                          />

                          <Table className="table mb-0">
                            <tbody>
                              {/* IFSC */}
                              <tr>
                                <th>IFSC:</th>
                                <td>
                                  {edit && clickedIndexEdit === index ? (
                                    <Select
                                      defaultValue={{
                                        label: item.IFSC,
                                        value: 0,
                                      }}
                                      options={BankIfscOptions}
                                      onKeyDown={onIfscKeyUp}
                                      isLoading={bankLoading}
                                      onChange={onIfscChange}
                                      styles={customStyles}
                                      disabled={clickedIndexEdit !== index}
                                    />
                                  ) : (
                                    <span>{item.IFSC || "N/A"}</span>
                                  )}
                                </td>
                              </tr>

                              {/* Bank Name */}
                              <tr>
                                <th>Bank Name:</th>
                                <td>
                                  <span>
                                    {clickedIndexEdit === index &&
                                    showFieldsWhileEditing
                                      ? bankIfscCodeList.bankName
                                      : item.bank_name || "N/A"}
                                  </span>
                                </td>
                              </tr>

                              {/* Branch Name */}
                              <tr>
                                <th>Branch Name:</th>
                                <td>
                                  <span>
                                    {clickedIndexEdit === index &&
                                    showFieldsWhileEditing
                                      ? bankIfscCodeList.branchName
                                      : item.branch_name || "N/A"}
                                  </span>
                                </td>
                              </tr>

                              {/* Account Number */}
                              <tr>
                                <th>Account Number:</th>
                                <td>
                                  {edit && clickedIndexEdit === index ? (
                                    <Input
                                      type="text"
                                      name="account_number"
                                      className="p-2 rounded-1"
                                      defaultValue={item.account_number}
                                      disabled={clickedIndexEdit !== index}
                                      onChange={EditInputChange}
                                    />
                                  ) : (
                                    <span>{item.account_number || "N/A"}</span>
                                  )}
                                </td>
                              </tr>

                              {/* Account Holder */}
                              <tr>
                                <th>Account Holder:</th>
                                <td>
                                  {edit && clickedIndexEdit === index ? (
                                    <Input
                                      type="text"
                                      name="account_holder"
                                      className="p-2 rounded-1"
                                      defaultValue={item.account_holder}
                                      disabled={clickedIndexEdit !== index}
                                      onChange={EditInputChange}
                                      placeholder="Enter Holder Name"
                                    />
                                  ) : (
                                    <span>{item.account_holder || "N/A"}</span>
                                  )}
                                </td>
                              </tr>

                              {/* Account Type */}
                              <tr>
                                <th>Type of Account:</th>
                                <td>
                                  {edit && clickedIndexEdit === index ? (
                                    <Input
                                      type="select"
                                      className="form-control  fs-6 rounded-1"
                                      defaultValue={item.account_type}
                                      disabled={clickedIndexEdit !== index}
                                      onChange={EditInputChange}
                                    >
                                      <option value="select">
                                        Select Type
                                      </option>
                                      <option
                                        id="Saving"
                                        value="Saving Account"
                                      >
                                        Savings Account
                                      </option>
                                      <option
                                        id="Current"
                                        value="Current Account"
                                      >
                                        Current Account
                                      </option>
                                      <option id="Loan" value="Loan Account">
                                        Loan Account
                                      </option>
                                    </Input>
                                  ) : (
                                    <span>{item.account_type || "N/A"}</span>
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                          <div className="col-12 text-end  mt-2 ">
                            {edit && clickedIndexEdit === index ? (
                              <>
                                <Button
                                  id="editDetails"
                                type=""
                                  className=" submit-btn"
                                  onClick={onSubmitEdit}
                                  size="sm"
                                >
                                  Submit
                                </Button>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>

                        <div className="col-12 text-end p-2 mt-2 mb-0 d-lg-block d-md-none d-none">
                          {edit && clickedIndexEdit === index ? (
                            <>
                              <Button
                                id="editDetails"
                                type=""
                                className="submit-btn"
                                onClick={onSubmitEdit}
                                size="sm"
                              >
                                Submit
                              </Button>
                            </>
                          ) : (
                            <Button
                              id="editDetails"
                              type=""
                              className="buttonOrangeDefaultColor"
                              onClick={() => handleEditBank(index, item)}
                              size="sm"
                            >
                              Edit&nbsp; <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </>
            );
          })}
        </Row>
      )}

      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            Add Bank Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <form>
            <Row className="text-gray">
              <Col lg="4" className="mb-2 mt-1">
                <label className="text-black">IFSC</label>
                <Select
                  menuPlacement="auto"
                  options={BankIfscOptions}
                  onKeyDown={onIfscKeyUp}
                  onChange={onIfscChange}
                  isLoading={bankLoading}
                  className="SelectAgentClass mt-1"
                  styles={customStyles}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="bank_name"
                  value={bankIfscCodeList.bankName}
                  disabled
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="branch_name"
                  value={bankIfscCodeList.branchName}
                  disabled
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="number"
                  name="account_number"
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <CustomTextField
                  type="text"
                  name="account_holder"
                  onChange={onInputChange}
                />
              </Col>
              <Col lg="4" className="mb-4">
                <label className="text-black">Type of Account</label>
                <CustomTextField
                  type="select"
                 className="text-gray"
                  name="account_type"
                  style={{ padding: "7px"}}
                  onChange={onInputChange}
                >
                  <option value="select">Select Type</option>
                  <option id="savings" value="savings">
                    Savings
                  </option>
                  <option id="Current" value="Current">
                    Current Account
                  </option>
                </CustomTextField>
              </Col>
            </Row>

            <Button
              className={`submit-btn`}
              onClick={(e) => handleAddSubmit()}
              disabled={disableButton ? true : false}
              style={{ float: "right" }}
              size="sm"
            >
              Submit &nbsp;
              {disableButton ? <Spinner animation="border" size="sm" /> : ""}
            </Button>
            {showError ? (
              <div style={{ color: "red" }}>
                All The fields are mandatory **
              </div>
            ) : (
              ""
            )}
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Card>
  );
};

export default FarmerDetailsBank;
